interface MacroGrams {
  protein: number;
  carbs: number;
  fat: number;
}

interface MacroPercentages {
  protein: number;
  carbs: number;
  fat: number;
}

/**
 * Each macro's share of the calories contributed by all three macros.
 * Protein and carbs contribute 4 kcal/g; fat contributes 9 kcal/g.
 */
export const getMacroPercents = ({ protein, carbs, fat }: MacroGrams): MacroPercentages => {
  const proteinCalories = protein * 4;
  const carbsCalories = carbs * 4;
  const fatCalories = fat * 9;
  const totalMacroCalories = proteinCalories + carbsCalories + fatCalories;

  if (totalMacroCalories <= 0) {
    return { protein: 0, carbs: 0, fat: 0 };
  }

  return {
    protein: Math.round((proteinCalories / totalMacroCalories) * 100),
    carbs: Math.round((carbsCalories / totalMacroCalories) * 100),
    fat: Math.round((fatCalories / totalMacroCalories) * 100),
  };
};

/**
 * Keep bar widths within the available track.
 */
export const getMacroBarWidth = (percent: number): number => Math.min(percent, 100);
